import script from "./enrolledTutors.vue?vue&type=script&setup=true&lang=js"
export * from "./enrolledTutors.vue?vue&type=script&setup=true&lang=js"

import "./enrolledTutors.vue?vue&type=style&index=0&id=cedd3982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cedd3982"]])

export default __exports__